<header class="divinea-header"
    [ngClass]="{'header-transparent': transparencyService.isTransparent$ | async, 'header-not-transparent': !(transparencyService.isTransparent$ | async)}">
    <div class="container">
    <p-menubar [model]="items">
        <ng-template  pTemplate="start">
            <a  *ngIf="!(transparencyService.isTransparent$ | async);" [href]="(languageService.getLanguagePrefix() || '') + '/'">
                <img src="../../assets/images/logo.svg" height="40" class="mr-2 logo" />
            </a>
            <a *ngIf="transparencyService.isTransparent$ | async;" [href]="(languageService.getLanguagePrefix() || '') + '/'">
                <img src="../../assets/images/logow-divinea.png" height="40" class="mr-2 logo" />
            </a>
        </ng-template>
    </p-menubar>
</div>
</header>